module.exports = __webpack_public_path__ + "img/browser@2x.7d02a206.png";